let appStore = null;

export function setAppStore(store) {
	appStore = store;
}

export function getAppStore() {
	return appStore;
}
